module.exports = __webpack_public_path__ + "static/media/bsns-scooter.dd8adf27.png";